import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router'
import {DrinkAutomaticMachineComponent} from "./drink-automatic-machine/drink-automatic-machine.component";
import {FillMachineComponent} from "./fill-machine/fill-machine.component";





export const router : Routes = [

  { path:'drinkMachine' , component: DrinkAutomaticMachineComponent },

  { path:'fillCoins' , component: FillMachineComponent },



];


export const routes: ModuleWithProviders = RouterModule.forRoot(router);



// WEBPACK FOOTER //
// /Applications/WebStorm.app/Contents/bin/untitled3/Users/vidhyasagar/WebstormProjects/RealTimeAnalytics/CoinMachine/src/app/app.router.ts